export const sortOrder = [
  { title: 'All', value: 'all' },
  { title: 'Paid', value: 'paid' },
  { title: 'Pending', value: 'pending' },
  { title: 'Cancelled', value: 'cancelled' },
];

export const contactTypes = [
  { label: 'Request dataset', value: 'Request Dataset' },
  { label: 'Custom request', value: 'Custom request' },
  { label: 'Facing an issue', value: 'Facing an issue' },
];
